import { Injectable } from '@angular/core';
import { EndPointService } from 'src/app/core/services/end-point.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';
import { DelegatedTeam } from 'src/app/auth/models/UserData';
import { MenuItem } from '../models/MenuItem';
import { MenuItemFavourite } from '../models/MenuItemFavourite';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _baseUrl = '/api/';
  private _fetch = 'menuitem/menuitem';

  constructor(private _endPointService: EndPointService) {
    this.registerEndPoints();
  }

  private registerEndPoints(): void {
    this._endPointService.registerEndPoint<MenuItem>('menu_fetch', `${this._baseUrl}${this._fetch}`, true);
    this._endPointService.registerEndPoint<MenuItemFavourite>('menu_favourites', `${this._baseUrl}menuitem/favourites`, true);
    this._endPointService.registerEndPoint<void>('menu_favourites_add', `${this._baseUrl}menuitem/addfavourite`, false, ['menu_favourites']);
    this._endPointService.registerEndPoint<void>('menu_favourites_remove', `${this._baseUrl}menuitem/removefavourite`, false, ['menu_favourites']);
    this._endPointService.registerEndPoint<void>('menu_favourites_updatelabel', `${this._baseUrl}menuitem/updatefavouritelabel`, false, ['menu_favourites']);
    this._endPointService.registerEndPoint<void>('menu_favourites_sort', `${this._baseUrl}menuitem/sortfavourites`, false);
  }

  public fetchMenu(fetch = false): Observable<MenuItem> {
    const data = {};
    if (localStorage.getItem('manager_view') === '1') {
      data['manager'] = true;
    }

    const delegate = <DelegatedTeam>(
      JSON.parse(localStorage.getItem('delegate'))
    );
    if (delegate) {
      data['delegateId'] = delegate.studentId;
    }

    const observableMenuItems = this._endPointService
      .call<MenuItem>('menu_fetch', data, fetch)
      .pipe(
        map((menuItem: MenuItem) => {
          return new MenuItem(menuItem);
        })
      );

    return observableMenuItems;
  }

  public getFavourites(fetch: boolean = false): Observable<MenuItemFavourite[]> {
    const data = {};
    if (localStorage.getItem('manager_view') === '1') {
      data['manager'] = true;
    }

    const delegate = <DelegatedTeam>(JSON.parse(localStorage.getItem('delegate')));
    if (delegate) {
      data['delegateId'] = delegate.studentId;
    }

    const favourites = this._endPointService.call<MenuItemFavourite[]>('menu_favourites', data, fetch);
    return favourites;
  }

  public addFavourite(menuItemId: number, title: string): Observable<void> {
    const data = {};
    if (localStorage.getItem('manager_view') === '1') {
      data['manager'] = true;
    }

    const delegate = <DelegatedTeam>(JSON.parse(localStorage.getItem('delegate')));
    if (delegate) {
      data['delegateId'] = delegate.studentId;
    }

    data['menuItemId'] = menuItemId;
    data['title'] = title;

    return this._endPointService.call<void>('menu_favourites_add', data, false);
  }

  public removeFavourite(menuItemId: number): Observable<void> {
    const data = {};
    if (localStorage.getItem('manager_view') === '1') {
      data['manager'] = true;
    }

    const delegate = <DelegatedTeam>(JSON.parse(localStorage.getItem('delegate')));
    if (delegate) {
      data['delegateId'] = delegate.studentId;
    }

    data['menuItemId'] = menuItemId;

    return this._endPointService.call<void>('menu_favourites_remove', data, false);
  }


  public updateFavouriteLabel(activeFavourite: MenuItemFavourite) {
    return this._endPointService.call<void>('menu_favourites_updatelabel', activeFavourite, false);
  }

  public sortFavourites(favourites: MenuItemFavourite[]): Observable<void> {
    const data = {};
    if (localStorage.getItem('manager_view') === '1') {
      data['manager'] = true;
    }

    const delegate = <DelegatedTeam>(JSON.parse(localStorage.getItem('delegate')));
    if (delegate) {
      data['delegateId'] = delegate.studentId;
    }

    data['favourites'] = favourites;

    return this._endPointService.call<void>('menu_favourites_sort', data, false);
  }

}
